<template>
  <div>
    <div :class="{ rocketUp: comin, rocketDown: leavin }" @click="scrollPos()">
      <svg
        id="Capa_1"
        data-name="Capa 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 490.52 256.01"
      >
        <path
          class="cls-1"
          d="M487.41,355.05,252.74,120.38a10.67,10.67,0,0,0-15.08,0L3,355.05a10.67,10.67,0,0,0,15.09,15.08L245.19,143,472.31,370.15a10.66,10.66,0,0,0,15.08-15.08Z"
          transform="translate(0 -117.26)"
        />
        <path
          d="M479.86,373.27a10.68,10.68,0,0,1-7.55-3.12L245.19,143,18.08,370.15A10.67,10.67,0,0,1,3,355.07L237.66,120.4a10.67,10.67,0,0,1,15.08,0L487.41,355.07a10.67,10.67,0,0,1-7.55,18.2Z"
          transform="translate(0 -117.26)"
        />
      </svg>
    </div>
    <v-app>
      <v-main>
        <router-view />
      </v-main>
    </v-app>
  </div>
</template>

<script>
export default {
  name: "App",
  data: () => ({
    topPoint: 0,
  }),
  computed: {
    comin() {
      return this.topPoint > 250 ? true : false;
    },
    leavin() {
      return this.topPoint > 250 ? false : true;
    },
  },
  methods: {
    scrollPos() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  },
  mounted() {
    window.addEventListener("scroll", () => {
      this.topPoint = window.scrollY;
    });
  },
};
</script>

<style lang="scss" scoped>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

html {
  scroll-behavior: smooth;
}

.rocketUp {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #0f172a;
  position: fixed;
  bottom: 30px;
  right: 30px;
  z-index: 9999;
  animation: comingUp 0.5s linear;
  &:hover {
    cursor: pointer;
    transition: 0.2s;
    box-shadow: 1px 0px 10px 0px #0f172a;
  }
  svg {
    width: 100%;
    max-width: 25px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    path {
      fill: white;
    }
  }
}

.rocketDown {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #0f172a;
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 9999;
  animation: comingDown 0.5s linear forwards;
  &:hover {
    cursor: pointer;
    transition: 0.2s;
    box-shadow: 1px 0px 20px 0px #0f172a;
  }
  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    path {
      fill: white;
    }
  }
}

@keyframes comingUp {
  from {
    bottom: -50px;
    opacity: 0;
  }
  to {
    visibility: visible;
    bottom: 20px;
    opacity: 1;
  }
}

@keyframes comingDown {
  from {
    bottom: 20px;
    opacity: 1;
  }
  to {
    visibility: hidden;
    bottom: -50px;
    opacity: 0;
  }
}
</style>